export const formatRating = (rating: number) => {
  return rating.toFixed(1);
};

export const formatReviewCount = (count: number) => {
  return `${count} ${count === 1 ? "review" : "reviews"}`;
};

export const getDisplayableRating = (
  rating: number | null | undefined,
  reviewCount: number | null | undefined,
) => {
  if (
    typeof rating !== "number" ||
    typeof reviewCount !== "number" ||
    rating < 0 ||
    rating > 5 ||
    reviewCount < 1
  ) {
    return null;
  }

  return { rating, reviewCount };
};
